import React from 'react'
import { AllForms } from '../Components/AllForms'
import { Box } from '@chakra-ui/react';

export const MyForms = () => {
  return (
    <Box>
      <AllForms />
    </Box>
  )
}
